import { Theme } from '@mui/material/styles';
import { createStyles } from "@mui/styles";
import { AppRootStyleClasses, GlobalStyles, LayoutMinWidth, LayoutToolbarHeight } from "../../common-styles";

const appStyle = (theme: Theme) => createStyles({
    ...AppRootStyleClasses(theme),

    "@global": {
        ...GlobalStyles(theme),

        "body": {
            minWidth: [LayoutMinWidth, "!important"],
            backgroundColor: [theme.palette.grey["200"],"!important"] ,
        },

        
        ".content": {
            position: "relative",
            marginTop: LayoutToolbarHeight,
            marginLeft: 80,
            padding: theme.spacing(),
            minWidth: 0
        }
    },
});

export default appStyle;
